<template>
  <div class="subscribe-success">
    <div class="img-container">
      <SuccessImage />
    </div>
    <div class="info">
      <h4>Enjoy the insights</h4>
      <p>
        You already are a Proxify member, so just click the button and get your
        freebie. Enjoy all the insights!
      </p>
      <a
        class="btn"
        @click="onClick"
      >
        {{ buttonTitle }}
      </a>
    </div>
  </div>
</template>

<script>
import SuccessImage from '~/components/Common/Svg/LeadGenPage/SuccessImage';
export default {
  components: {
    SuccessImage,
  },
  props: {
    buttonTitle: {
      type: String,
      default: 'Download PDF',
    },
  },
  emits: ['downloadFile'],
  methods: {
    onClick() {
      this.$emit('downloadFile');
      this.$analytics.track('CTA Clicked', {
        cta_name: this.buttonTitle,
        section: 'Hero section',
        page_name: 'Lead gen page v1',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import './SubscribeSuccess.scss';
</style>
